import { ref, onMounted, onUnmounted } from 'vue';
import useDisplay from './useDisplay';

export default function useScrollSticky(onlyMobile, scrollDir) {
  const showSticky = ref(false);
  let lastScrollPosition;

  function onScroll() {
    const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
    if (currentScrollPosition < 0) return;

    if (scrollDir === 'up') {
      showSticky.value = currentScrollPosition <= lastScrollPosition;
    } else if (scrollDir === 'down') {
      showSticky.value = currentScrollPosition >= lastScrollPosition;
    }
    lastScrollPosition = currentScrollPosition;
  }

  const start = () => {
    lastScrollPosition = window.scrollY || document.documentElement.scrollTop;
    window.addEventListener('scroll', onScroll);
  };

  onMounted(() => {
    if (onlyMobile) {
      const { isMobile } = useDisplay();
      if (isMobile.value) start();
    } else {
      start();
    }
  });

  onUnmounted(() => window.removeEventListener('scroll', onScroll));

  return {
    showSticky,
  };
}
